import CONFIG from '../../config';

const actions = {
  card(context) {
    context.commit('ADD_LOG', { request: 'card' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('card'), {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'card' });
          resolve(response.data);
        })
        .catch((err) => {
          context.dispatch('resolveError', err)
            .catch((resolvedError) => {
              reject(resolvedError);
            });
          context.commit('REMOVE_LOG', { request: 'card' });
        });
    });
  },
  cardSetPin(context, params) {
    context.commit('ADD_LOG', { request: 'cardSetPin' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('cardSetPin'), params.patchParams, {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'cardSetPin' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'cardSetPin' });
          context.dispatch('resolveError', err)
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  cardLockUnlock(context, params) {
    context.commit('ADD_LOG', { request: 'cardLockUnlock' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('cardLockUnlock'), params.patchParams, {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'cardLockUnlock' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'cardLockUnlock' });
          context.dispatch('resolveError', err)
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  cardChannelLimit(context, params) {
    context.commit('ADD_LOG', { request: 'cardChannelLimit' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('cardChannelLimit'), params.patchParams, {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'cardChannelLimit' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'cardChannelLimit' });
          context.dispatch('resolveError', err)
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  cardChannelStatus(context, params) {
    context.commit('ADD_LOG', { request: 'cardChannelStatus' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('cardChannelStatus'), params.patchParams, {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'cardChannelStatus' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'cardChannelStatus' });
          context.dispatch('resolveError', err)
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },

};
export default actions;
